import { render, staticRenderFns } from "./MgmtCompany.vue?vue&type=template&id=7268fb31&scoped=true&"
import script from "./MgmtCompany.vue?vue&type=script&lang=js&"
export * from "./MgmtCompany.vue?vue&type=script&lang=js&"
import style0 from "./MgmtCompany.vue?vue&type=style&index=0&id=7268fb31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7268fb31",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow,VTextField})
